import { render, staticRenderFns } from "./OrderDelete.vue?vue&type=template&id=6dfff4d6"
import script from "./OrderDelete.vue?vue&type=script&lang=js"
export * from "./OrderDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports